/**
 * 根据 /api/Enterprise/Simple 返回的 logoFlag 判断是否为银宝Logo
 * 后端约定：1-默认Logo  2-银宝Logo  其他-自定义上传Url地址
 */
export function isYinbaoLogoByFlag(logoFlag) {
  return String(logoFlag) === "2";
}

export const YINBAO_LOGO = require("../assets/images/yinbao_logo1.jpg");
